'use strict';

import domready from "domready";

function initFormScrollIntoView() {
  const currentFormId = window.location.hash.replace(/#/, '');
  if (!currentFormId) return;

  const currentForm = document.querySelector(`form#${currentFormId}`);
  if (!currentForm) return;

  currentForm.scrollIntoView({ behavior: 'instant' });
}

domready(() => {
  initFormScrollIntoView();
});
